
import Vue from 'vue'
import TextInput from '~/components/inputs/TextInput.vue'
import PasswordInput from '~/components/inputs/PasswordInput.vue'
import EmailInput from '~/components/inputs/EmailInput.vue'
import ErrorToast from '~/components/toasts/ErrorToast.vue'
import { inputsValid } from '~/core/functions/inputsValid'
import { loginAction } from '~/core/functions/login'
import { generateHead } from '~/core/config/head.config'

export default Vue.extend({
  name: 'RegistrationPage',
  components: { TextInput, PasswordInput, EmailInput, ErrorToast },
  layout: 'landing',
  auth: false,
  data() {
    return {
      repititionError: false,
      passwordInputClass: {
        'form-error': false,
      },
      disabled: true,
      registrationError: false,
      loginError: false,
      buttonLoading: false,
    }
  },
  /* istanbul ignore next */
  head() {
    const head = generateHead('mhLanding')
    head.bodyAttrs.class = 'public-area-theme mh'
    return { ...head }
  },
  updated() {
    this.validateInput()
  },
  methods: {
    validateInputAndPasswordMatch() {
      this.passwordMatch()
      this.validateInput()
    },
    validateInput() {
      const fields = ['firstName', 'lastName', 'email', 'password', 'repeatedPassword']
      const valid = inputsValid(this, fields, [], [])
      valid ? (this.$data.disabled = false) : (this.$data.disabled = true)
    },
    passwordMatch(): void {
      // @ts-ignore
      if (this.$refs.repeatedPassword.$data.value === '') {
        this.repititionError = false
        this.passwordInputClass['form-error'] = false
      } else if (
        // @ts-ignore
        this.$refs.password.$data.value !== this.$refs.repeatedPassword.$data.value
      ) {
        this.repititionError = true
        this.passwordInputClass['form-error'] = true
      } else {
        this.repititionError = false
        this.passwordInputClass['form-error'] = false
      }
    },
    submitRegistration(): void {
      this.$data.buttonLoading = true
      // @ts-ignore
      const email = this.$refs.email.$data.value
      // @ts-ignore
      const password = this.$refs.password.$data.value
      // @ts-ignore
      const firstName = this.$refs.firstName.$data.value
      // @ts-ignore
      const lastName = this.$refs.lastName.$data.value
      const url = `https://env-4296205.jcloud-ver-jpc.ik-server.com/rest/register`
      this.$axios
        .$post(url, {
          input: {
            email,
            password,
            firstName,
            lastName,
          },
        })
        .then(() => {
          this.$data.buttonLoading = false
          loginAction(this, email, password)
        })
        .catch(() => {
          this.$data.registrationError = true
        })
    },
  },
})
